import { render, staticRenderFns } from "./UserInfoTableColumn.vue?vue&type=template&id=a005c82e&scoped=true&"
import script from "./UserInfoTableColumn.vue?vue&type=script&lang=js&"
export * from "./UserInfoTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoTableColumn.vue?vue&type=style&index=0&id=a005c82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a005c82e",
  null
  
)

export default component.exports